module.exports = __webpack_public_path__ + "img/DAY1-1.b5506cb3.jpg";